import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';
const bgColor = {
  red: '01,02,07,08,12,13,18,19,23,24,29,30,34,35,40,45,46',
  blue: '03,04,09,10,14,15,20,25,26,31,36,37,41,42,47,48',
  green: '05,06,11,16,17,21,22,27,28,32,33,38,39,43,44,49'
};
let treeChildren = (index, data, Vue) => {
  var arr = [];
  if (data) {
    for (let i = 1; i < 11; i++) {
      var obj = {};
      // obj.title = `${i}`;
      obj.renderHeader = (h, row) => {
        return <span class="header_span">{i}</span>;
      };
      obj.align = 'center';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        if (row.row.ball_json[name].nums[i] == 0) {
          return <span class="red">{data[row.index].ballList[index]}</span>;
        } else {
          // console.log(Vue.divideList, 'Vue.divideList');
          // return <span class="lost_info">{row.row.ball_json[name].nums[i]}</span>;
          if (Vue.divideList[i] > row.index) {
            return <span class="divide_lost_info lost_info">{row.row.ball_json[name].nums[i]}</span>;
          } else {
            return <span class="lost_info">{row.row.ball_json[name].nums[i]}</span>;
          }
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let xingtaiChildren = data => {
  var arr = [];
  // var shape = ['总数', '单双', '大小', '七色波'];
  var shape = ['总数', '单双', '大小'];

  var str = ['single', 'double', 'big', 'small'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var balls = row.row.ballList.reduce((a, b) => {
          return Number(a) + Number(b);
        });
        if (i == 0) {
          return <span>{balls}</span>;
        } else if (i == 1) {
          return <span class={`color_${balls % 2 ? 1 : 0}`}>{balls % 2 == 0 ? '双' : '单'}</span>;
        } else if (i == 2) {
          return <span class={`color_${balls >= 175 ? 0 : 1}`}>{balls >= 175 ? '大' : '小'}</span>;
        } else if (i == 3) {
          var num = balls % 3;
          if (num == 0) {
            return <span>红</span>;
          } else if (num == 1) {
            return <span>蓝</span>;
          } else {
            return <span>绿</span>;
          }
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let teChildren = data => {
  var arr = [];
  var shape = ['单双', '大小', '合单双', '和大小', '尾大小'];
  var str = ['0', '1', '2'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var num = row.row.ballList.slice(-1);
        var n = num.join('');
        var he = Number(n[0]) + Number(n[1]);

        if (i == 0) {
          return <span class={`color_${Number(num) % 2}`}>{Number(num) % 2 == 0 ? '双' : '单'}</span>;
        } else if (i == 1) {
          return <span class={`color_${Number(num) > 6 ? 0 : 1}`}>{Number(num) > 25 ? '大' : '小'}</span>;
        } else if (i == 2) {
          return <span class={`color_${he % 2}`}>{he % 2 == 0 ? '合双' : '合单'}</span>;
        } else if (i == 3) {
          return <span class={`color_${he > 7 ? 0 : 1}`}>{he > 7 ? '合大' : '合小'}</span>;
        } else {
          return <span class={`color_${Number(n[1]) > 5 ? 0 : 1}`}>{Number(n[1]) > 5 ? '尾大' : '尾小'}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

const lhc = data => {
  let list = Vue => {
    return Vue.showMobile
      ? Vue.curKey == 'lhckjhm'
        ? [
            {
              title: '时间',
              align: 'center',
              render: (h, { row }) => {
                return <span>{dayjs(row.result_time).format('HH:mm')}</span>;
              }
            },
            {
              // title: '日期/期数',
              title: '期号',
              align: 'center',
              // key: "issue_id",
              width: 140,
              className: `table_issueId`,
              render: (h, { row }) => {
                return <span>{row.issue_id.substring(row.issue_id.length - 4)}</span>;
              }
            },
            {
              title: '正码',
              align: 'center',
              width: 400,
              className: `table_issueId`,
              render: (h, { row }) => {
                return (
                  <div class="lhc_ball">
                    {row.ballList.slice(0, 6).map((x, i) => {
                      var a = row[Vue.sxType];
                      return (
                        <div>
                          <span class={`ball_${bgColor.red.indexOf(x) > -1 ? '0' : bgColor.blue.indexOf(x) > -1 ? '2' : '1'} ball`}>{x}</span>
                        </div>
                      );
                    })}
                  </div>
                );
              }
            },
            {
              title: `特码`,
              align: 'center',
              width: '80',
              render: (h, { row }) => {
                return (
                  <div>
                    <span
                      class={`ball_${
                        bgColor.red.indexOf(row.ballList.slice(-1)) > -1 ? '0' : bgColor.blue.indexOf(row.ballList.slice(-1)) > -1 ? '2' : '1'
                      } ball`}
                    >
                      {row.ballList.slice(-1)}
                    </span>
                  </div>
                );
              }
            }
          ]
        : [
            {
              title: '时间',
              align: 'center',
              render: (h, { row }) => {
                return <span>{dayjs(row.resultDate).format('HH:mm')}</span>;
              }
            },
            {
              // title: '日期/期数',
              title: '期号',
              align: 'center',
              // key: "issue_id",
              width: 140,
              className: `table_issueId`,
              render: (h, { row }) => {
                return <span>{row.issue_id.substring(row.issue_id.length - 4)}</span>;
              }
            },
            {
              title: '总和',
              align: 'center',
              className: `table_issueId`,
              render: (h, { row }) => {
                return <span>{count(row.ballList)}</span>;
              }
            },
            {
              title: '单双',
              align: 'center',
              className: `table_issueId`,
              render: (h, { row }) => {
                let sum = count(row.ballList);
                return <span>{sum % 2 == 0 ? '双' : '单'}</span>;
              }
            },
            {
              title: '大小',
              align: 'center',
              className: `table_issueId`,
              render: (h, { row }) => {
                let sum = count(row.ballList);
                return <span>{sum >= 175 ? '大' : '小'}</span>;
              }
            }
          ]
      : [
          {
            // title: '日期/期数',
            title: '期号',
            align: 'center',
            key: 'issue_id',
            width: 140,
            className: `table_issueId`
          },
          {
            title: '正码',
            align: 'center',
            width: 400,
            className: `table_issueId`,
            render: (h, { row }) => {
              return (
                <div class="lhc_ball">
                  {row.ballList.slice(0, 6).map((x, i) => {
                    var a = row[Vue.sxType];
                    var opacity;
                    if ((Vue.showList.length > 0 && !Vue.showList.includes(i)) || (Vue.condition.length > 0 && !Vue.condition.includes(a[i]))) {
                      var className = 'no_select';
                      opacity = 0.4;
                    }
                    //  else if (Vue.showList.length > 0 && !Vue.showList.includes(i) && Vue.condition.length > 0 && !Vue.condition.includes(a[i])) {
                    //   var className = 'no_select';
                    //   opacity = 0.4;
                    // }
                    else {
                      var className = 'select';
                      opacity = 1;
                    }
                    return (
                      <div class={`lhc_ball_list ${className}}`} style={`opacity: ${opacity}`}>
                        <span class={`ball_${bgColor.red.indexOf(x) > -1 ? '0' : bgColor.blue.indexOf(x) > -1 ? '2' : '1'} ball`}>{x}</span>
                        <span>{a[i]}</span>
                      </div>
                    );
                  })}
                </div>
              );
            }
          },
          {
            title: `特码`,
            align: 'center',
            width: '80',
            render: (h, { row }) => {
              var a = row[Vue.sxType];
              var className;
              var opacity;
              if ((Vue.showList.length > 0 && !Vue.showList.includes(6)) || (Vue.condition.length > 0 && !Vue.condition.includes(a[6]))) {
                var className = 'no_select';
                opacity = 0.4;
              }
              // else if (Vue.showList.length > 0 && !Vue.showList.includes(6) && Vue.condition.length > 0 && !Vue.condition.includes(a[6])) {
              //   var className = 'no_select';
              //   opacity = 0.4;
              // }
              else {
                var className = 'select';
                opacity = 1;
              }
              return (
                <div class={`lhc_ball_list ${className}}`} style={`opacity: ${opacity}`}>
                  <span
                    class={`ball_${
                      bgColor.red.indexOf(row.ballList.slice(-1)) > -1 ? '0' : bgColor.blue.indexOf(row.ballList.slice(-1)) > -1 ? '2' : '1'
                    } ball`}
                  >
                    {row.ballList.slice(-1)}
                  </span>
                  <span>{a[6]}</span>
                </div>
              );
            }
          },
          {
            title: '总和',
            align: 'center',
            className: `table_issueId`,
            children: xingtaiChildren(data)
          },
          {
            title: '特码',
            align: 'center',
            className: `table_issueId`,
            children: teChildren(data)
          }
        ];
  };

  return { list };
};
export default lhc;



// WEBPACK FOOTER //
// ./src/pages/Trend/LhcJishikaijiang/columns/lhc.js